import axios from "axios";
import { useEffect } from "react";

const StickerRedirect = props => {

    const id = props.match.params.id;

    useEffect(() => {

        window.localStorage.setItem('sticker', id);

        const event = {type: {id: 'click'}, action: {id: id}};

        const defaultUrl = 'https://www.learnylib.com/';

        axios.post('/api/v2/sticker/events', event)
            .then(r => { window.location.href = r.data?.action?.targetUrl || defaultUrl })
            .catch(e => { window.location.href = defaultUrl })


    }, [id])


    return <></>

}

export default StickerRedirect;